{
  "title": "Notifications",
  "titleUnread": "Notifications, unread: {{count}}",
  "intro": "Budget thresholds and decisions on raise requests. E-mail and Telegram come later.",
  "empty": "No notifications",
  "emptyLead": "Notifications about your projects' budgets appear here: spending thresholds and raise requests.",
  "markAll": "Mark all as read",
  "markRead": "Mark as read",
  "all": "All notifications",
  "unread": "Unread",
  "threshold": {
    "actual": "{{project}}: {{percent}}\u00a0% of the budget spent ({{amount}} of {{budget}}), threshold {{threshold}}\u00a0%.",
    "forecast": "{{project}}: the month's forecast is {{percent}}\u00a0% of the budget ({{amount}} of {{budget}}), threshold {{threshold}}\u00a0%."
  },
  "raiseRequested": "{{project}}: {{name}} asks to raise the budget by {{amount}} ({{kind}}).",
  "raise": {
    "approved": "{{project}}: the budget raise of {{amount}} was approved.",
    "rejected": "{{project}}: the budget raise of {{amount}} was rejected."
  },
  "approvalRequested": "{{project}}: key “{{key}}” asks to approve {{action}} ({{target}}).",
  "approvalDecided": {
    "executed": "{{project}}: the request of key “{{key}}” ({{action}}) was approved and run.",
    "failed": "{{project}}: the request of key “{{key}}” ({{action}}) was approved but not done.",
    "rejected": "{{project}}: the request of key “{{key}}” ({{action}}) was rejected.",
    "expired": "{{project}}: the request of key “{{key}}” ({{action}}) expired undecided."
  }
}
